import { render, staticRenderFns } from "./NewThread.vue?vue&type=template&id=d41128b4&scoped=true"
import script from "./NewThread.vue?vue&type=script&lang=ts"
export * from "./NewThread.vue?vue&type=script&lang=ts"
import style0 from "./NewThread.vue?vue&type=style&index=0&id=d41128b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41128b4",
  null
  
)

export default component.exports